<template>
  <div :class="this.searchActive? 'header active': 'header'">
    <SearchBar :modal.sync="modal"/>
      <transition name="fade">
        <LoginModal v-if='modal'/>
      </transition>
    <div class="header__container">
      <a
        href="https://www.polskieradio.pl/9,Trojka"
        target="_blank"
        tabindex="0"
        aria-label="Trójka"
      >
        <div class="header__trojka-logo">
        </div>
      </a>
      <div class="header__trojka-banner">
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar/Desktop/SearchBar.vue";
import LoginModal from "@/components/LoginModal/Desktop/LoginModal.vue";
import mixin from '../mixin';

export default {
  mixins: [mixin],
  components: {
    SearchBar,
    LoginModal
  },
  data() {
    return {

    }
  }


}
</script>

<style scoped lang="scss">
  .header {
    width: 100%;
    height: 38rem;
    background-image: url('/img/hdback.jpg');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    transition: height 0.2s linear;
    .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
 &.active {
   height:  40.8125rem;
 }
.fade-enter, .fade-leave-to {
  opacity: 0;
}
    &__container {
      width: 100%;
      height: 100%;
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
    }
    a {
      z-index: 2;
          display: block;
    width: 9rem;
    }
    &__trojka-logo {
      width: 9rem;
      height: 3rem;
margin-top: 4rem;      
background-image: url('/icons/trojka.png');
      background-position: center;
      background-size: 100%;
      background-repeat: no-repeat;
      cursor: pointer;
    }
    &__trojka-banner {
      width: 42.45rem;
      height: 26.375rem;
      margin-top: -7rem;
      background-image: url('/img/banner.png');
      background-position: center;
      background-size: 100%;
      background-repeat: no-repeat;
    }
  }
</style>
